module.exports = __webpack_public_path__ + "static/alishas-art-a7d525bfc686541482fcba1b2af38b9a.svg";